import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'

const border = `1px solid ${colors.silver}`

export const tableStyle = {
  table: {
    composes: 'report-text-block-width',
    display: 'table',
    fontSize: 13,
    '& p': {
      margin: 0
    }
  },
  header: {
    display: 'table-row',
    backgroundColor: colors.gunMetal,
    color: 'white'
  },
  headerCell: {
    display: 'table-cell',
    position: 'relative',
    padding: 5,
    height: 25,
    minWidth: 20
  },
  row: {
    display: 'table-row',
    '&:nth-child(even)': {
      backgroundColor: colors.concrete
    }
  },
  dataCell: {
    extend: 'headerCell',
    borderRight: border,
    borderBottom: border,
    '&:first-child': {
      borderLeft: border
    },
    '& ol.list': {
      paddingInlineStart: '22px'
    },
    '& .ql-editor ol.list': {
      paddingInlineStart: 0
    },
    '& ul.list': {
      paddingInlineStart: '16px'
    },
    '& .ql-editor ul.list': {
      paddingInlineStart: 0
    }
  }
}

export const useTableStyles = createUseStyles(tableStyle)
